import { Control, Controller, FieldErrors } from 'react-hook-form';
import { Label } from '../../../components/ui/label';
import LabelWithInfo from '../../../components/LabelWithInfo/LabelWithInfo';
import CustomInput from '../../../components/CustomInput/CustomInput';
import ChatbotStylingFormValues from '../../../types/ChatbotStylingFormValues';

interface ColorInputProps {
  readonly id: string;
  readonly label: string;
  readonly name: keyof ChatbotStylingFormValues;
  readonly control: Control<ChatbotStylingFormValues>;
  readonly errors: FieldErrors<ChatbotStylingFormValues>;
  readonly tooltip?: string;
}

export default function ColorInput({
  id,
  label,
  name,
  control,
  errors,
  tooltip
}: ColorInputProps): JSX.Element {
  return (
    <div className='space-y-2'>
      {tooltip ? (
        <LabelWithInfo htmlFor={id} info={tooltip}>
          {label}
        </LabelWithInfo>
      ) : (
        <Label htmlFor={id}>{label}</Label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <div className='flex flex-row items-start gap-2 min-w-0'>
            <input
              id={id}
              type='color'
              value={String(field.value ?? '')}
              onChange={(e) => field.onChange(e.target.value)}
              className='w-9 h-9 rounded-md border cursor-pointer flex-shrink-0'
            />
            <CustomInput
              type='text'
              value={String(field.value ?? '')}
              onChange={(e) => field.onChange(e.target.value)}
              placeholder='#000000'
              containerClassName='flex-1 min-w-0'
              className='!w-full'
            />
          </div>
        )}
      />
      {errors[name] && (
        <p className='text-destructive text-sm'>{errors[name]?.message}</p>
      )}
    </div>
  );
}
